import {AxiosRequestConfig} from 'axios';
import request from '../../axios';

export interface IGetDetailedSubBrandProps {
  page_size?: number;
}

export const getDetailedSubBrandList = async (
  brandId: number,
  pageNumber: number,
  props: IGetDetailedSubBrandProps = {},
) => {
  const {page_size = 10} = props;

  const {data}: {data: IGetDetailedSubBrandResponse} = await request.get(
    `api/v2/warehouse/list-detailed-sub-brand/${brandId}`,
    {
      params: {
        page: pageNumber,
        page_size,
      },
    } as AxiosRequestConfig,
  );

  return data;
};
